import Splide from '@splidejs/splide';

export default class TestimonialsCarousel extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        let splide = new Splide('#testimonials-carousel', {
            type   : 'loop',
            perPage: 1,
            arrows: false
        });
        splide.mount();
    }

}